import { flattenValues } from '@uniformdev/canvas';
import { isRichTextValueConsideredEmpty, type RichTextNode } from '@uniformdev/richtext';

import { Speakers } from '@/libraries/design/patterns/speakers/src/speakers';
import { RichTextComponent } from '@/libraries/design/utils';

import { richTextToHTML } from '../../../../clients/uniform-client/enhancers/utils';

import type { Document } from '@contentful/rich-text-types';

interface UniformSpeakerProps {
	name: string;
	photoSrc: string;
	jobTitle: string;
	company?: string;
	shortBiography?: { root: RichTextNode };
	shortBiographyContentfulRichText?: Document;
}

interface UniformSpeakersProps {
	speakers: UniformSpeakerProps[];
	title?: string;
}

const UniformSpeakers = ({ speakers, title }: UniformSpeakersProps) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const flattenedSpeakers = flattenValues(speakers as any) as UniformSpeakerProps[];
	const reshapedSpeakers = flattenedSpeakers.map((flattenedProps) => {
		return {
			...flattenedProps,
			bio: flattenedProps.shortBiographyContentfulRichText ? (
				<RichTextComponent text={richTextToHTML(flattenedProps.shortBiographyContentfulRichText)} />
			) : !isRichTextValueConsideredEmpty(flattenedProps.shortBiography) ? (
				<RichTextComponent uniformRichText={flattenedProps.shortBiography?.root} />
			) : undefined,
		};
	});
	return <Speakers speakers={reshapedSpeakers} title={title} />;
};

export default UniformSpeakers;
